module.exports = __webpack_public_path__ + "static/dmon-001-672b0837b2ab31352c909c37e54b40d1.jpg";